
import { CtCatalogueProduct, CtProduct } from '@/models/interfaces/content-type'
import { ContentType } from '@/services/directr'
import {defineComponent, PropType, ref, watch} from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
    name: 'AddProductsDialog',
    components: {},
    props: {
      show: {
        type: Boolean,
        required: true
      },
      draftProductIds: {
        type: Array as PropType<CtCatalogueProduct['id'][]>,
        required: true
      },
      catalogueId: {
        type: String,
        required: true
      }
    },
    emits: ['update:show', 'add-products'],
    expose: ['refresh'],
    setup (props) {
      const $store = useStore()
      const $directr = $store.getters['Services/Directr']

      const collection = ref<CtProduct[]>([])

      const model = ref($store.getters[`${ContentType.Product}/Model`])

      const searchQuery = ref<string | null>(null)

      const queryHandler = (query?: string | null) => {
        searchQuery.value = query ?? null
        $directr.get(ContentType.Product, [{
          select: [`${ContentType.Product}.*`],
          from: [ContentType.Product],
          where: {
            and: [
              { not: [{ __id: { in: props.draftProductIds } }] },
              { not: [
                  {
                    inSubquery: ['__id', {
                      select: ['id'],
                      from: [ContentType.CatalogueProduct],
                      where: {
                        catalogue: props.catalogueId,
                        not: [{ id: null }]
                      }
                    }]
                  }
                ]
              },
              {
                or: query ? [
                  { ilike: ['title', query] },
                  { ilike: ['sku', query] },
                  { ean: { overlap: query?.split(','), type: 'varchar' } },
                  {
                    inSubquery: ['components[1]', {
                      select: ['__id'],
                      from: [ContentType.StockItem],
                      where: {
                        or: [
                          { ilike: ['title', query] },
                          { ilike: ['sku', query] },
                          { ean: { overlap: query?.split(','), type: 'varchar' } }
                        ]
                      }
                    }]
                  }
                ] : undefined
              }
            ].filter(Boolean)
          },
          limit: 100
        }], { orm: true }).then(products => {
          collection.value = products.items
        }).catch(e => {
          console.error('Error fetching products', e)
        })
      }

      watch(() => [props.catalogueId, props.draftProductIds], () => {
        if (props.show) {
          searchQuery.value = null
          queryHandler()
        } else {
          collection.value = []
        }
      })

      const refresh = () => {
        if (props.catalogueId || collection.value.length) {
          queryHandler(searchQuery.value)
        }
      }

      watch(() => props.show, (value) => {
        if (value) {
          queryHandler(searchQuery.value)
        }
      })

      return {
        collection,
        model,
        queryHandler,
        refresh,
      }
    }
})
